import(/* webpackMode: "eager" */ "/Volumes/repository/devel/electrical/commerce/frontends/storefront/app/[locale]/error.tsx");
